<div class="content">
    <app-catalog-ui *ngIf="options.showCatalog" [options]="options"></app-catalog-ui>

    <div class="outerViewer">
        <as-split *ngIf="!isMobile" unit="percent" gutterAriaLabel="adjustable divider between two views" #split="asSplit" (dragEnd)="onDragEnd()">
            <as-split-area [size]="20" #area1="asSplitArea" id="basketUI">
                <app-basket-ui [items]="items" [options]="options"></app-basket-ui>
            </as-split-area>
            <as-split-area [size]="50" #area2="asSplitArea" id="viewerUI">
                <app-viewer-ui #viewerUI [options]="options"></app-viewer-ui>
            </as-split-area>
            <as-split-area [size]="30" #area3="asSplitArea" id="detailsUI">
                <div *ngIf="clickedItemID == ''" class="loading">
                    {{"message.selectItem" | translate}}
                </div>

                <mat-tab-group *ngIf="clickedItemID != ''" animationDuration="0">
                    <mat-tab [label]="'title.configuration' | translate">
                        <app-property-ui [options]="options"></app-property-ui>
                    </mat-tab>
                    <mat-tab [label]="'title.articleAdditionally' | translate">
                        <app-additionally-ui [options]="options"></app-additionally-ui>
                    </mat-tab>
                    <mat-tab [label]="'title.documents' | translate">
                        <app-pcon-facts-ui [options]="options"></app-pcon-facts-ui>
                    </mat-tab>
                </mat-tab-group>
            </as-split-area>
        </as-split>

        <div #mobile *ngIf="isMobile" class="mobile">
            <app-basket-ui #basketUI [items]="items" [options]="options"></app-basket-ui>
            <div class="viewerWrapper">
                <app-viewer-ui #viewerUI [options]="options"></app-viewer-ui>
            </div>
            <app-property-ui #propertyUI [options]="options"></app-property-ui>
        </div>
    </div>
</div>